export const QUEST_JOURNAL_TABS = [
  { id: 'active', label: 'Активные' },
  { id: 'available', label: 'Доступные' },
  { id: 'completed', label: 'Завершённые' },
  { id: 'daily', label: 'Ежедневные' },
  { id: 'events', label: 'События' },
]

export function normalizeQuestJournal(value) {
  if (!Array.isArray(value)) return []
  return value
    .filter(item => item && typeof item === 'object' && typeof item.id === 'string')
    .map(item => {
      const steps = Array.isArray(item.steps)
        ? item.steps.filter(step => step && typeof step === 'object').map(step => ({
            id: String(step.id || ''),
            text: String(step.text || ''),
            done: step.done === true,
          }))
        : []
      const totalSteps = Math.max(steps.length, Math.floor(Number(item.totalSteps) || 0))
      const doneSteps = Math.min(totalSteps, Math.max(0, Math.floor(Number(item.doneSteps) || steps.filter(step => step.done).length)))
      return {
        ...item,
        id: item.id,
        name: String(item.name || item.id),
        hint: String(item.hint || ''),
        status: ['active', 'locked', 'completed'].includes(item.status) ? item.status : 'locked',
        daily: item.daily === true,
        event: item.event === true,
        done: item.done === true || item.status === 'completed',
        claimed: item.claimed === true,
        locked: item.locked === true || item.status === 'locked',
        steps,
        doneSteps,
        totalSteps,
        reward: item.reward && typeof item.reward === 'object' ? item.reward : {},
      }
    })
}

export function questsForTab(quests, tab) {
  switch (tab) {
    case 'active':
      return quests.filter(item => item.status === 'active' && item.doneSteps > 0 && !item.daily)
    case 'available':
      return quests.filter(item => item.status === 'active' && item.doneSteps === 0 && !item.daily)
    case 'completed':
      return quests.filter(item => item.done)
    case 'daily':
      return quests.filter(item => item.daily)
    case 'events':
      return quests.filter(item => item.event)
    default:
      return []
  }
}

export function questTabCounts(quests) {
  return Object.fromEntries(QUEST_JOURNAL_TABS.map(tab => [tab.id, questsForTab(quests, tab.id).length]))
}

export function firstPopulatedQuestTab(quests) {
  return QUEST_JOURNAL_TABS.find(tab => questsForTab(quests, tab.id).length)?.id || 'active'
}

export function questProgress(quest) {
  if (!quest?.totalSteps) return 0
  return Math.max(0, Math.min(1, quest.doneSteps / quest.totalSteps))
}
